import { ReduxStore } from 'store/types';

function importSpreadsheetId(state: ReduxStore): number | null {
  return state.product.importSpreadsheet.id;
}

export default importSpreadsheetId;
